import { useState } from 'react'
import { callApi } from '@/utils/http-utils'

export type ModalityPatch = {
  name?: string
  description?: string
  keyFeatures?: string | null
  status?: boolean
  isManualEntry?: boolean
  changeDescription?: string | null
}

export function useUpdateModality() {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string>('')

  const updateModality = async (id: string | number, payload: ModalityPatch) => {
    setSubmitting(true)
    setError('')
    try {
      const res = await callApi(`/data-api/modalities/${id}`, {
        method: 'PATCH',
        body: payload,
        accept: 'application/json',
      })

      const ct = res.headers.get('content-type') || ''
      if (!ct.includes('application/json')) {
        const text = await res.text()
        throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
      }
      return await res.json()
    } catch (e: any) {
      setError(e?.message || 'Failed to update modality')
      throw e
    } finally {
      setSubmitting(false)
    }
  }

  return { updateModality, submitting, error, setError }
}
